<template>
  <div class="FormatButtons">
    <UiIcon
      :title="$t('FormatButtons.Bold')"
      @click="toggleFormat('bold')"
      class="ToolbarButton"
      :class="{ 'is-active': isActive.bold }"
      value="mdi:format-bold"
    />

    <UiIcon
      :title="$t('FormatButtons.Italic')"
      @click="toggleFormat('italic')"
      class="ToolbarButton"
      :class="{ 'is-active': isActive.italic }"
      value="mdi:format-italic"
    />

    <UiIcon
      :title="$t('FormatButtons.Strike')"
      @click="toggleFormat('strike')"
      class="ToolbarButton"
      :class="{ 'is-active': isActive.strike }"
      value="mdi:format-strikethrough"
    />

    <UiIcon
      :title="$t('FormatButtons.Underline')"
      @click="toggleFormat('underline')"
      class="ToolbarButton"
      :class="{ 'is-active': isActive.underline }"
      value="mdi:format-underline"
    />
  </div>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon } from '@/modules/ui/components';

export default {
  components: {
    UiIcon,
  },
  mixins: [useI18n],

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  methods: {
    toggleFormat(format) {
      switch (format) {
        case 'bold':
          return this.editor.chain().focus().toggleBold().run();
        case 'italic':
          return this.editor.chain().focus().toggleItalic().run();
        case 'strike':
          return this.editor.chain().focus().toggleStrike().run();
        case 'underline':
          return this.editor.chain().focus().toggleUnderline().run();
      }
    },
  },

  computed: {
    isActive() {
      return {
        bold: this.editor.isActive('bold'),
        italic: this.editor.isActive('italic'),
        strike: this.editor.isActive('strike'),
        underline: this.editor.isActive('underline'),
      };
    },
  },

  i18n: {
    en: {
      'FormatButtons.Bold': 'Bold',
      'FormatButtons.Italic': 'Italic',
      'FormatButtons.Strike': 'Strikethrough',
      'FormatButtons.Underline': 'Underline',
    },
    es: {
      'FormatButtons.Bold': 'Negrita',
      'FormatButtons.Italic': 'Cursiva',
      'FormatButtons.Strike': 'Tachado',
      'FormatButtons.Underline': 'Subrayado',
    },
    de: {
      'FormatButtons.Bold': 'Fett',
      'FormatButtons.Italic': 'Kursiv',
      'FormatButtons.Strike': 'Durchgestrichen',
      'FormatButtons.Underline': 'Unterstrichen',
    },
    fr: {
      'FormatButtons.Bold': 'Gras',
      'FormatButtons.Italic': 'Italique',
      'FormatButtons.Strike': 'Barré',
      'FormatButtons.Underline': 'Souligné',
    },
    it: {
      'FormatButtons.Bold': 'Grassetto',
      'FormatButtons.Italic': 'Corsivo',
      'FormatButtons.Strike': 'Barrato',
      'FormatButtons.Underline': 'Sottolineato',
    },
    pt: {
      'FormatButtons.Bold': 'Negrito',
      'FormatButtons.Italic': 'Itálico',
      'FormatButtons.Strike': 'Riscado',
      'FormatButtons.Underline': 'Sublinhado',
    },
  },
};
</script>